import { render, staticRenderFns } from "./ScharffLogo_2.vue?vue&type=template&id=575a9a52&"
import script from "./ScharffLogo_2.vue?vue&type=script&lang=js&"
export * from "./ScharffLogo_2.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports